import CategoryList from "../../components/CategoryList";
import CategoryItem from "../../components/CategoryList/components/CategoryItem";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";

const QuickLinksModule = ({
	title,
	links,
	slider,
}: Queries.QuickLinksModuleFragment) => {
	return (
		<GridItem fullWidth={!!slider}>
			<CategoryList label={title ?? undefined} withSlider={!!slider}>
				{links?.map(
					(link, index) =>
						link?.link_text &&
						link.image?.filename && (
							<CategoryItem
								key={`${link.link_text}-${index}`}
								label={link.link_text}
								href={getUrlFromStoryblokLink(link.link)}
								image={{
									src: link.image.filename,
									alt: link.image.alt ?? undefined,
								}}
								isSliderItem={!!slider}
								{...(link.tag ? { tag: link.tag } : {})}
							/>
						),
				)}
			</CategoryList>
		</GridItem>
	);
};

export default QuickLinksModule;
